import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import {
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Paper,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Popper,
    ClickAwayListener,
    Typography,
    CircularProgress,
    Tabs,
    Tab,
    Box,
    InputAdornment,
    IconButton,
} from "@material-ui/core";
import Slide from '@material-ui/core/Slide';
import { FaHotel } from "react-icons/fa";
import { FaHospital } from "react-icons/fa";

// Icons
import LocationOnIcon from "@material-ui/icons/LocationOn";
import HomeIcon from "@material-ui/icons/Home";
import SchoolIcon from "@material-ui/icons/School";
import ClearIcon from "@material-ui/icons/Clear";
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';
import { withStyles } from '@material-ui/core/styles';
import BusinessIcon from '@material-ui/icons/Business';
// Style
import { makeStyles } from "@material-ui/core/styles";
import "./style.css"
// Component
import GoogleMaps from "./GoogleMap";
import {addressDetail, searchAddressSuggestions} from "../../store/actions/userAction";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Snackbar from "@material-ui/core/Snackbar";
import t from "../../i18n/translate";
import countryCodes from "../../data/countrycodes.json";
import Select from "react-select";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    dropdown: {
        background: "white",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        borderRadius: "4px",
        zIndex: 10,
        maxHeight: "500px",
        overflowY: "auto",
	    WebkitOverflowScrolling: "touch", // Enable momentum scrolling on iOS Safari
    },
    listItem: {
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    textField: {
        border:"2px",
        "& label.Mui-focused": {
            color: "#9cc54b",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#9cc54b",
            },
            "&:hover fieldset": {
                borderColor: "#9cc54b",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#9cc54b",
            },
        },
    },
    button: {
        color: "#fff",
        backgroundColor: "#9cc54b",
        "&:hover": {
            backgroundColor: "#87b23f",
        },
    },
    buttonClose: {
        color: "#fff",
        backgroundColor: "#9c9b9b",
        "&:hover": {
            backgroundColor: "#87b23f",
        },
    },
    buttonMarkLocation: {
        color: "#fff",
        backgroundColor: "#9cc54b",
        margin: "0 5px",
        "&:hover": {
            backgroundColor: "#87b23f",
        },
    },
    label: {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        paddingRight: theme.spacing(2),
        color: theme.palette.text.primary,
    },
    icon: {
        color: "#9cc54b",
    },
    noResults: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: "#9cc54b",
    },
}));
const PrimaryAddressCheckbox = withStyles({
    root: {
        color: "#9cc54b",
        '&$checked': {
            color: "#9cc54b",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CustomerAddress = ({ props, open, handleToggleModal, selectedAddressToUpdate, setSelectedAddressToUpdate, type,handleSelectAddressWhenCreateNew }) => {
    const classes = useStyles();
    let user = localStorage.getItem("user");
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [countries, setCountries] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [latitude, setLatitude] = useState(11.585059400964562);
    const [longitude, setLongitude] = useState(104.91634500155044);
    const [loading, setLoading] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const anchorRef = useRef(null);
    const debounceTimeout = useRef(null);
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [placeID, setPlaceID] = useState("")
    const [updating,setUpdating] = useState(false)
	const [isInRange, setIsInRange] = useState(true);
    const [addressDetails, setAddressDetails] = useState({
        houseAndStreet: "", // Combined houseNumber and streetDetail
        apartmentName: "",
        city: "",
        district: "",
        commune: "",
        deliveryInstruction: "",
        label: "Home",
        primaryAddress: false,
        userId: "",
        addressId: "",
        areaDetails:"",
        countryCode: { label:"Cambodia (+855)", value: 855 },
        phone: "",
        firstName:"",
        lastName:"",
    });

    const handleToggleError = (message = "") => {
        setErrorMessage(message)
        setShowError(!showError)
    }

    const checkCountryCode = async (code) => {
        return countries.find((e) => e.value == code)
    }

    const handleSelectCountryCode = (e) => {
        setAddressDetails({...addressDetails, countryCode: e});
    };

    useEffect(() => {
        if(type === "create"){
            setUpdating(true)
            handleResetField()
        }
    }, []);

    useEffect(() => {
        const fetchCountryData = () => {
            const nations = countryCodes.map((country_code) => ({
                value: country_code.dial_code,
                label: `${country_code.name} (+${country_code.dial_code})`
            }));
            setCountries(nations);

            if (type === "create" && user) {
                const parsedUser = JSON.parse(user);
                const country = nations.find((e) => e.value === parsedUser.country_code);
                setAddressDetails((prev) => ({
                    ...prev,
                    countryCode: country,
                    firstName: parsedUser.first_name,
                    lastName: parsedUser.last_name,
                    phone: parsedUser.phone
                }));
            }
        };

        fetchCountryData();
    }, [type, user, countryCodes, user]);

    // Existing functions (unchanged)
    const handleSearchChange = async (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(async () => {
            if (value.length > 1) {
                const addressSuggestions = await searchAddressSuggestions(value);
                if (addressSuggestions) {
                    setFilteredSuggestions(addressSuggestions.data);
                    setDropdownOpen(true);
                } else {
                    setDropdownOpen(false);
                }
            } else {
                setDropdownOpen(false);
            }
        }, 500);
    };

    const handleSelectSuggestion = async (address) => {
        let lat,lng;
        if(address.location) {
            lat = address.location.latitude;
            lng = address.location.longitude;
            setLatitude(lat);
            setLongitude(lng);
        }else{
            setPlaceID(address.placeId)
        }
        setSelectedAddressToUpdate({...selectedAddressToUpdate, latitude: lat, long: lng})
        setSearchTerm(address.detail);
        setDropdownOpen(false);
        setUpdating(true)
        let body = {};
        if(address.location){
            body.lat = lat
            body.lng = lng
        }else{
            body.placeId = address.placeId
        }
        let addressDetails = await addressDetail(body);
        if (addressDetails) {
            if(addressDetails.country !== "Cambodia"){
                setPlaceID("")
	            setLatitude("")
                setLongitude("")
	            setIsInRange(false)
	            setSearchTerm("")
                handleToggleError(t('shop_select_location_outside_cambodia_error'))
	            return; // Stop execution if outside Cambodia
            }

	        // Only proceed if location is in Cambodia
	        setIsInRange(true)
            setLatitude(addressDetails.latitude);
            setLongitude(addressDetails.longitude);
            setSelectedAddressToUpdate({...selectedAddressToUpdate, latitude: addressDetails.latitude, long: addressDetails.longitude})
            setSearchTerm(addressDetails.label);
            setAddressDetails({
                ...addressDetails,
                city: addressDetails.city,
                houseAndStreet: addressDetails.houseAndStreet,
                district: addressDetails.district,
                commune: addressDetails.commune,
                primaryAddress: selectedAddressToUpdate?.is_default,
                areaDetails: addressDetails?.label,
                label: "Home",
                apartmentName: addressDetails?.apartmentName,
            });
        }
    };

    const handleClickAway = () => {
        setDropdownOpen(false);
    };

    const handleMarkPrimaryAddress = () => {
        setAddressDetails(prevState => ({
            ...addressDetails,
            primaryAddress: !prevState.primaryAddress,
        }));
    };

    const handleMarkerDragEnd = async (props, { lat, lng }) => {
        setPlaceID('')
        setLoading(true);
        setUpdating(true)
        let body = {};
        if(placeID){
            body.placeId = placeID
        }else{
            body.lat = lat
            body.lng = lng
        }
        let address = await addressDetail(body);
        if (address) {
            if(address.country !== "Cambodia"){
                setPlaceID("")
	            setLatitude("")
                setLongitude("")
	            setIsInRange(false)
	            setSearchTerm("")
	            setLoading(false)
                handleToggleError(t('shop_select_location_outside_cambodia_error'))
	            return; // Stop execution if outside Cambodia
            }

	        // Only proceed if location is in Cambodia
	        setIsInRange(true)
            setLatitude(lat);
            setLongitude(lng);
            setSelectedAddressToUpdate({...selectedAddressToUpdate, latitude: lat, long: lng})
            setSearchTerm(address.label);
            setAddressDetails({
                ...addressDetails,
                city: address.city,
                houseAndStreet: address.houseAndStreet,
                district: address.district,
                commune: address.commune,
                primaryAddress: selectedAddressToUpdate?.is_default,
                areaDetails: address?.label,
                apartmentName: address?.apartmentName,
            });
        }
        setLoading(false);
    };

    const setLatLng = (latlng) => {
        setLatitude(latlng.lat);
        setLongitude(latlng.lng);
    }

    const myLocation = async (props, { lat, lng }) => {
        setLoading(true);
        let address = await addressDetail({ lat, lng });
        setUpdating(true)
        if (address) {
            setLongitude(lng);
            setLatitude(lat);
            setSearchTerm(address.label);
            setSelectedAddressToUpdate({...selectedAddressToUpdate, latitude: lat, long: lng})
            setAddressDetails({
                ...addressDetails,
                city: address.city,
                houseAndStreet: address.houseAndStreet,
                district: address.district,
                commune: address.commune,
                // primaryAddress: selectedAddressToUpdate?.is_default,
                areaDetails: address.label,
                apartmentName: address?.apartmentName,
            });
        }
        setLoading(false);
    };

    const fetchAddress = async (props) => {
        if (selectedAddressToUpdate) {
            setLongitude(selectedAddressToUpdate.long);
            setLatitude(selectedAddressToUpdate.latitude);
            setLoading(true);
            setSearchTerm(selectedAddressToUpdate.area_details);
            setAddressDetails({
                ...addressDetails,
                city: selectedAddressToUpdate?.city,
                houseAndStreet: selectedAddressToUpdate?.house_and_street,
                district: selectedAddressToUpdate?.district,
                commune: selectedAddressToUpdate?.commune,
                primaryAddress: selectedAddressToUpdate?.is_default,
                deliveryInstruction: selectedAddressToUpdate?.delivery_instructions,
                label: selectedAddressToUpdate?.nick_name,
                userId: selectedAddressToUpdate?.cust_id,
                addressId: selectedAddressToUpdate?.address_id,
                apartmentName: selectedAddressToUpdate?.apartment_name,
                areaDetails: selectedAddressToUpdate.area_details,
                firstName: selectedAddressToUpdate?.first_name,
                lastName: selectedAddressToUpdate?.last_name,
                phone: selectedAddressToUpdate?.mobile_number,
                countryCode: await checkCountryCode(selectedAddressToUpdate?.country_code)
            });
            setLoading(false);
        }
    };

    const handleResetField = () => {
        setErrors(null)
        setUpdating(false)
        setAddressDetails({
            houseAndStreet: "", // Combined houseNumber and streetDetail
            apartmentName: "",
            city: "",
            district: "",
            commune: "",
            deliveryInstruction: "",
            label: "Home",
            primaryAddress: false,
            userId: "",
            addressId: "",
            firstName: "",
            lastName: "",
            phone: "",
            countryCode: {
                label:"Cambodia (+855)",
                value: 855
            }
        })
        setErrors({
            houseAndStreet: "",
            apartmentName: "",
            city: "",
            district: "",
            commune: "",
            deliveryInstruction: "",
        });
        setLatitude(null)
        setLongitude(null)
        setTabIndex(0)
        setSelectedAddressToUpdate(null)
    };

    const handleMarkLocation = async (tap=1) => {
        setLoading(true);
        setLoading(false);
        console.log(latitude,longitude)
        setTabIndex(tap);
        let body = {};
        if(placeID){
            body.placeId = placeID
        }else{
            body.lat = latitude
            body.lng = longitude
        }
        let detail = await addressDetail(body);
        if (detail && (type === "create" || updating)) {
            setSearchTerm(detail.label);
            setAddressDetails({
                ...addressDetails,
                areaDetails: detail.label,
                city: detail.city,
                houseAndStreet: detail.houseAndStreet,
                district: detail.district,
                commune: detail.commune,
                apartmentName: detail.apartmentName
            });
        }
    };

    const [errors, setErrors] = useState({
        houseAndStreet: "",
        apartmentName: "",
        city: "",
        district: "",
        commune: "",
        deliveryInstruction: "",
        phone: ""
    });

    const handleConfirmAddress = async () => {
	    // Critical: Check if location is in Cambodia range
	    if (!isInRange) {
		    handleToggleError(t('shop_select_location_outside_cambodia_error'))
		    return;
	    }

	    // Validate latitude and longitude exist
	    if (!latitude || !longitude) {
		    handleToggleError("Please select a valid location on the map")
		    return;
	    }

        // Field validation
        const newErrors = {};
        let isValid = true;

        // Validate houseAndStreet
        if (!addressDetails?.houseAndStreet?.trim()) {
            newErrors.houseAndStreet = "House and Street is required";
            isValid = false;
        }

        // // Validate city
        // if (!addressDetails?.city?.trim()) {
        //     newErrors.city = "City is required";
        //     isValid = false;
        // }
        //
        // // Validate district
        // if (!addressDetails?.district?.trim()) {
        //     newErrors.district = "District is required";
        //     isValid = false;
        // }
        //
        // // Validate commune
        // if (!addressDetails?.commune?.trim()) {
        //     newErrors.commune = "Commune is required";
        //     isValid = false;
        // }

        // Validate apartmentName
        // if (!addressDetails?.apartmentName?.trim()) {
        //     newErrors.apartmentName = "Apartment Name is required";
        //     isValid = false;
        // }

        // Delivery Instruction (optional, but let's validate it's not too long)
        if (addressDetails?.deliveryInstruction && addressDetails?.deliveryInstruction.length > 250) {
            newErrors.deliveryInstruction = "Delivery Instructions is too long (max 500 characters)";
            isValid = false;
        }

        if (
            !addressDetails?.phone ||
            addressDetails.phone.length > 15
        ) {
	        newErrors.phone = "Phone must be digits only, 8 to 15 characters long";
            isValid = false;
        }

        if (!isValid) {
            setErrors(newErrors);
            return; // Prevent proceeding if validation fails
        }
        await handleSubmit()
    };

    const handleSubmit = async () => {
        let body = {
            apartment_name: addressDetails.apartmentName,
            area_details: addressDetails.areaDetails,
            city: addressDetails.city,
            nick_name: addressDetails.label,
            latitude: latitude,
            long: longitude,
            delivery_instructions: addressDetails.deliveryInstruction,
            is_default: addressDetails.primaryAddress,
            house_and_street: addressDetails.houseAndStreet,
            commune: addressDetails.commune,
            district: addressDetails.district,
            first_name: addressDetails?.firstName,
            last_name: addressDetails?.lastName,
            mobile_number: addressDetails?.phone,
            country_code: addressDetails?.countryCode.value,
        };
        let user = localStorage.getItem("user");
        if(addressDetails.userId){
            body.cust_id = addressDetails.userId
        }else{
            let customer = JSON.parse(user);
            body.cust_id = customer.cust_id
        }

        if(addressDetails.addressId){
            body.address_id = addressDetails.addressId
        }
        if (addressDetails.addressId) {
            await props.updateAddress(body);
        } else {
            await props.addAddress(body);
            if(props.location.pathname === "/checkout") {
                let address = await props.getAddress()
                if (address && address.length > 0)
                    handleSelectAddressWhenCreateNew(address[0])
            }
        }
        handleToggleModal();
        handleResetField()
    };
    // Clear delivery instructions
    const handleClearDeliveryInstruction = () => {
        setAddressDetails({ ...addressDetails, deliveryInstruction: "" });
    };

    const handleClearSearchSuggesstion = () => {
        setSearchTerm("");
    };

    const onMapZoom = (lat,lng) => {
        setLatitude(lat)
        setLongitude(lng)
    };

    return (
        <Dialog
            TransitionComponent={Transition}
            open={open}
            onClose={() => {
                handleToggleModal();
                handleResetField();
            }}
            aria-labelledby="dialog-title"
            fullWidth
            scroll="paper"
            style={{
	            height: "100%"
            }}
            maxWidth="md"
            PaperProps={{
	            style: {
		            WebkitTransform: "translateZ(0)",
		            transform: "translateZ(0)",
		            maxHeight: "90vh",
		            display: "flex",
		            flexDirection: "column"
	            }
            }}
        >
            <DialogTitle id="dialog-title" style={{ color: "#9cc54b" }}>
                <PersonPinCircleIcon style={{fontSize:"32px"}} className={classes.icon}/>{"Delivery Address"}
            </DialogTitle>
	        <DialogContent style={{
		        WebkitOverflowScrolling: 'touch',
		        overflowY: 'auto',
		        overscrollBehavior: 'contain',
		        msOverflowStyle: 'auto',
		        scrollbarWidth: 'auto'
	        }}>
                {tabIndex === 0 && (
                    <Grid TransitionComponent={Transition} container spacing={3}>
                        <Grid item xs={12} style={{ position: "relative" }}>
                            <TextField
                                fullWidth
                                label="Search Place Suggestions"
                                variant="outlined"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                onFocus={handleSearchChange}
                                inputRef={anchorRef}
                                className={classes.textField}
                                InputProps={{
                                    endAdornment: searchTerm ? (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClearSearchSuggesstion} edge="end">
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                            <Popper
                                open={dropdownOpen}
                                anchorEl={anchorRef.current}
                                placement="bottom-start"
                                style={{
                                    width: anchorRef.current ? anchorRef.current.clientWidth : "100%",
                                    zIndex: 1300,
                                }}
                            >
                                <ClickAwayListener onClickAway={handleClickAway}>
                                    <Paper className={classes.dropdown} style={{ width: "100%" }}>
                                        <List>
                                            {filteredSuggestions && filteredSuggestions?.length > 0 ? (
                                                filteredSuggestions?.map((suggestion) => (
                                                    <ListItem
                                                        key={suggestion.id}
                                                        onClick={() => handleSelectSuggestion(suggestion)}
                                                        className={classes.listItem}
                                                        button
                                                    >
                                                        <ListItemIcon>
                                                            <LocationOnIcon className={classes.icon} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={suggestion.label} secondary={suggestion.detail} />
                                                    </ListItem>
                                                ))
                                            ) : (
                                                <Typography className={classes.noResults}>No results found</Typography>
                                            )}
                                        </List>
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>
                        </Grid>
                        <Grid item xs={12}>
                            <GoogleMaps
                                isMarkerShown={true}
                                latitude={latitude}
                                longitude={longitude}
                                onMarkerDragEnd={handleMarkerDragEnd}
                                onMyLocation={myLocation}
                                fetchAddress={fetchAddress}
                                onMapZoom={onMapZoom}
                                type={type}
                                addressDetails={addressDetails}
                                setLatLng={setLatLng}
                            />
                        </Grid>
                    </Grid>
                )}
                {tabIndex === 1 && (
                    <Grid TransitionComponent={Transition} container spacing={3}>
                        <Grid item xs={12}>
                            <GoogleMaps
                                isMarkerShown={true}
                                latitude={latitude}
                                longitude={longitude}
                                onMarkerDragEnd={handleMarkerDragEnd}
                                onMyLocation={myLocation}
                                fetchAddress={fetchAddress}
                                onMapZoom={onMapZoom}
                                type={type}
                                addressDetails={addressDetails}
                                setLatLng={setLatLng}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} className={classes.label}>
                            <Typography variant={"subtitle2"} style={{color:"#9cc54b",textAlign:"center", fontWeight:"bold"}}>Drag the pointer to the location on the map where the driver should meet you</Typography>
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            {/* City */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>City</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={addressDetails?.city}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, city: e.target.value })}
                                    // error={Boolean(errors?.city)}
                                    // helperText={errors?.city}
                                    disabled={true}
                                    className={classes.textField}
                                />
                            </Grid>

                            {/* District */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>District</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={addressDetails?.district}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, district: e.target.value })}
                                    // error={Boolean(errors?.district)}
                                    // helperText={errors?.district}
                                    disabled={addressDetails?.district}
                                    className={classes.textField}
                                />
                            </Grid>

                            {/* Commune */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Commune</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={addressDetails?.commune}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, commune: e.target.value })}
                                    // error={Boolean(errors?.commune)}
                                    // helperText={errors?.commune}
                                    disabled={addressDetails?.commune}
                                    className={classes.textField}
                                />
                            </Grid>

                            {/* House and Street */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>House and Street</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={addressDetails?.houseAndStreet}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, houseAndStreet: e.target.value })}
                                    error={Boolean(errors?.houseAndStreet)}
                                    helperText={errors?.houseAndStreet}
                                    className={classes.textField}
                                />
                            </Grid>

                            {/* Apartment */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Apartment</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={addressDetails?.apartmentName}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, apartmentName: e.target.value })}
                                    // error={Boolean(errors?.apartmentName)}
                                    // helperText={errors?.apartmentName}
                                    className={classes.textField}
                                />
                            </Grid>

                            {/* Delivery Instructions */}
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Delivery Instructions</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    minRows={4}
                                    value={addressDetails?.deliveryInstruction}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, deliveryInstruction: e.target.value })}
                                    className={classes.textField}
                                    error={Boolean(errors?.deliveryInstruction)}
                                    helperText={errors?.deliveryInstruction}

                                    InputProps={{
                                        endAdornment: addressDetails?.deliveryInstruction ? (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleClearDeliveryInstruction} edge="end">
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}
                                />
                            </Grid>

                            {/* Contact Information */}
                            <Grid item xs={12} sm={12} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Contact information</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Name</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder={"first name"}
                                    value={addressDetails?.firstName}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, firstName: e.target.value })}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder={"last name"}
                                    value={addressDetails?.lastName}
                                    onChange={(e) => setAddressDetails({ ...addressDetails, lastName: e.target.value })}
                                    className={classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>Phone</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Select
	                                value={addressDetails?.countryCode}
                                    placeholder={ "Select Code" }
                                    className="basic-single"
                                    classNamePrefix="select"
                                    options={countries}
                                    inputProps={{ autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                                    onChange={(e) => handleSelectCountryCode(e)}
	                                menuPortalTarget={document.body}
	                                menuPosition="fixed"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
	                                        minHeight: "55px",
	                                        borderColor: "#9cc54b",
	                                        boxShadow: 'none',
	                                        WebkitAppearance: 'none',
                                            "&:hover": {
                                                border: "2px solid #9cc54b",
	                                            borderColor: "#9cc54b",
                                            }
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
	                                        zIndex: 9999,
                                        }),
	                                    menuPortal: (provided) => ({
		                                    ...provided,
		                                    zIndex: 9999,
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
	                                        backgroundColor: state.isSelected ? "#9cc54b" : state.isFocused ? "rgba(156, 197, 75, 0.1)" : "white",
                                            color: state.isSelected ? "#fff" : "#333",
	                                        cursor: "pointer",
	                                        "&:active": {
                                                backgroundColor: "#9cc54b",
                                            },
                                        })
                                    }}
                                />
                                {Boolean(errors?.countryCodes) && (
                                    <div style={{ color: "red", marginTop: 4 }}>{errors?.countryCodes}</div>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type={"tel"}
                                    inputProps={{
	                                    pattern: "[0-9]*",
	                                    inputMode: "numeric"
                                    }}
                                    placeholder={"Phone Number"}
                                    value={addressDetails?.phone}
                                    onChange={(e) => {
	                                    const value = e.target.value.replace(/[^0-9]/g, '');
	                                    setAddressDetails({...addressDetails, phone: value});
                                    }}
                                    className={classes.textField}
                                    error={Boolean(errors?.phone)}
                                    helperText={errors?.phone}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} className={classes.label}>
                                <Typography className={"font-weight-bold"}>&nbsp;</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <FormControlLabel
                                    control={<PrimaryAddressCheckbox checked={addressDetails.primaryAddress} onChange={() => handleMarkPrimaryAddress()} name="Primary Address" />}
                                    label="Primary Address"
                                />
                            </Grid>
                        </Grid>
                        {/* Location Labeling */}
                        <Grid item xs={12} spacing={2}>
                            <Typography variant="subtitle1" className={"font-weight-bold"} style={{ marginBottom: "10px" }}>
                                Save this location for later
                            </Typography>
                            <Grid item className="mb-2" spacing={2} xs={12}>
                                <TextField
                                    fullWidth
                                    // label="Label"
                                    variant="outlined"
                                    value={addressDetails.label}
                                    className={classes.textField}
                                    onChange={(e) => setAddressDetails({ ...addressDetails,label: e.target.value})}
                                    style={{ marginTop: "10px" }}
                                />
                            </Grid>
                            <Grid container xs={12} spacing={2}>
                                {[
                                    { label: "Home", icon: <HomeIcon className="icon-shake" style={{ fontSize: "32px" }} /> },
                                    { label: "Office", icon: <BusinessIcon className="icon-shake" style={{ fontSize: "32px" }} /> },
                                    { label: "School", icon: <SchoolIcon className="icon-shake" style={{ fontSize: "32px" }} /> },
                                    { label: "Hospital", icon: <FaHospital className="icon-shake" style={{ fontSize: "32px" }} /> },
                                    { label: "Hotel", icon: <FaHotel className="icon-shake" style={{ fontSize: "32px" }} /> },
                                ].map(({ label, icon }) => (
                                    <Grid item xs={6} sm={2} key={label}>
                                        <div
                                            onClick={() => setAddressDetails({ ...addressDetails, label })}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "2px 16px",
                                                cursor: "pointer",
                                                backgroundColor: addressDetails.label === label ? "#9cc54b" : "transparent",
                                                color: addressDetails.label === label ? "#fff" : "#9cc54b",
                                                border: "2px solid #9cc54b",
                                                textAlign: "center",
                                            }}
                                            className={`address-box ${addressDetails.label === label ? "selected" : ""}`}
                                        >
                                            <Box style={{ marginBottom: "2px" }}>{icon}</Box>
                                            <Box>{label}</Box>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" width="100%">
                    {tabIndex === 1 && (
                        <Button
                            onClick={() => {
                                handleMarkLocation(0); // Add parentheses to call the function
                            }}
                            color="primary"
                            className={classes.button}
                        >
                            Back
                        </Button>
                    )}

                    <Box display="flex" justifyContent="space-between" width="100%">
                        <Button
                            onClick={() => {
                                handleToggleModal();
                                handleResetField()
                            }}
                            color="primary"
                            className={classes.buttonClose+ " mx-1"}
                        >
                            Close
                        </Button>
                        {tabIndex === 0 ? (
                            <Button
                                onClick={() => handleMarkLocation(1)} // Simplified for this example
                                className={classes.buttonMarkLocation}
                                autoFocus
                                disabled={!isInRange || loading}
                                startIcon={loading && <CircularProgress size={20} color="inherit" />}
                            >
                                {loading ? "" +
                                    "Add Address details" : "Add Address details"}
                            </Button>
                        ) : (
                            <Button
                                onClick={handleConfirmAddress}
                                className={classes.button}
                                autoFocus
                                disabled={!isInRange || loading}
                                startIcon={loading && <CircularProgress size={20} color="inherit" />}
                            >
	                            {loading ? "" + "Confirm address" : "Confirm address"}
                            </Button>
                        )}
                    </Box>
                </Box>
            </DialogActions>
            <Snackbar
                anchorOrigin={{ vertical:"top", horizontal:"center" }}
                open={showError}
                onClose={() => handleToggleError("")}
                message={errorMessage}
                autoHideDuration={2000}
                style={{fontSize:"35px"}}
                key="center-center" // ✅
                ContentProps={{
                    style: {
                        marginTop: "200px"
                    }
                }}
            />
        </Dialog>
    );
};

CustomerAddress.propTypes = {
    open: PropTypes.bool.isRequired,
    handleToggleModal: PropTypes.func.isRequired,
};

export default CustomerAddress;